<template>
  <div class="teachin-text">
      {{info||"暂时没有信息展示"}}
  </div>
</template>

<script>
export default {
    name:"wjText",
    props:["info"],
    data(){
        return {
            
        }
    }

}
</script>

<style scoped lang="less">
.teachin-text{
    text-align: left;
    min-height: 6rem;
    padding: 0.5rem 0.8rem;
}
</style>